import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardRootComponent } from './dashboard-root/dashboard-root.component';
import { AdminGuardService } from './services/admin-guard.service';
import { ConnectionResolver } from './services/connection-resolver.service';
import { LocationResolverService } from './services/location-resolver.service';
import { LoginGuardService } from './services/login-guard.service';

const dashboardRoutes: Routes = [
    {
        path: 'dashboard',
        component: DashboardRootComponent,
        canActivate: [LoginGuardService],
        resolve: {
            location: LocationResolverService,
            connection:ConnectionResolver
        },
        children: [
            { path: '', pathMatch: 'full', loadChildren: '../accounts/accounts.module#AccountsModule' },
            { path: 'locations', loadChildren: '../accounts/accounts.module#AccountsModule' },
        ]
    },
    {
        path: 'dashboard',
        component: DashboardRootComponent,
        canActivate: [LoginGuardService],
        children: [
            { path: 'settings', loadChildren: '../settings/settings.module#SettingsModule' },
            { path: 'help', loadChildren: '../help/help.module#HelpModule' },
            // { path: 'locations', loadChildren: '../accounts/accounts.module#AccountsModule', pathMatch: 'full' },
            // { path: 'admin', loadChildren: '../admin/admin.module#AdminModule' }
        ]
    },
    {
        path: 'dashboard',
        component: DashboardRootComponent,
        canActivate: [LoginGuardService, AdminGuardService],
        resolve: {
            location: LocationResolverService,
            connection:ConnectionResolver
        },
        children: [
            { path: 'admin', loadChildren: '../admin/admin.module#AdminModule', canLoad: [AdminGuardService] }
        ]
    },

    {
        path: 'dashboard/:locId',
        canActivate: [LoginGuardService],
        canActivateChild: [LoginGuardService],
        component: DashboardRootComponent,
        resolve: {
            location: LocationResolverService,
            connection:ConnectionResolver
        },
        children: [
            { path: 'irrigation', loadChildren: '../irrigation/irrigation.module#IrrigationModule' },
            { path: 'lighting', loadChildren: '../lighting/lighting.module#LightingModule' },
            { path: 'firmware', loadChildren: '../firmware/firmware.module#FirmwareModule' },
        ]
    },
    {
        path: 'dashboard',
        component: DashboardRootComponent,
        canActivate: [LoginGuardService],
        resolve: {
            location: LocationResolverService,
            connection:ConnectionResolver
        },

        children: [
            { path: '**', loadChildren: '../accounts/accounts.module#AccountsModule' }
        ]
    },
    {
        path: 'dashboard/account/edit',
        component: DashboardRootComponent,
        canActivate: [LoginGuardService],
        resolve: {
            location: LocationResolverService,
            connection:ConnectionResolver
        },
        children: [
            { path: '', pathMatch: 'full', loadChildren: '../accounts/accounts.module#AccountsModule' },
            // { path: 'locations', loadChildren: '../accounts/accounts.module#AccountsModule',pathMatch:'full' },
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(dashboardRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        LoginGuardService,
        AdminGuardService,
        LocationResolverService,
        ConnectionResolver,
    ]
})
export class CoreRoutingModule { }
